import type { ReactElement } from 'react';

import { SvgPromo } from '@/components/icons-eataly';
import { cn } from '@/lib/utils';
import type { EditorialPromotion } from '@/types/scapi';

interface CartEditorialPromotionsProps {
    promotions: EditorialPromotion[];
    presentation?: 'toast' | 'drawer';
}

export function CartEditorialPromotions({
    promotions,
    presentation,
}: CartEditorialPromotionsProps): ReactElement | null {
    const isToast = presentation === 'toast';
    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className="flex flex-col gap-2">
            {promotions.map((promotion) => {
                if (!promotion.calloutMsg || !promotion.name) {
                    return null;
                }
                return (
                    <div
                        key={promotion.id}
                        className={cn(
                            'flex flex-col justify-start gap-2 py-3 px-4 bg-neutral-90',
                            !isToast && 'rounded-lg border border-neutral-80'
                        )}>
                        <div className="flex items-center gap-2">
                            <SvgPromo className="size-6" />
                            <p className="body-copy-l-bold">{promotion.name}</p>
                        </div>
                        <div
                            className={cn('text-neutral-10 body-copy-m [&_strong]:font-bold')}
                            // eslint-disable-next-line react/no-danger -- BM/PIM-authored HTML
                            dangerouslySetInnerHTML={{
                                __html: promotion.calloutMsg,
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
}
